import { Layout, PtData as PtDataComponent } from "components"

export const PtData = () => {
 return (
  <Layout>
   <PtDataComponent />
  </Layout>
 )
}
